<div class="window-footer">
  <ng-container *ngIf="!(showCompletedButtons$ | async); else completed_container">
    <ng-container
      *ngIf="(hideActionButton$ | async) && (slidingWindowOptions$ | async)?.idleStateButtonText; else defaultButtons">
      <app-button [type]="ButtonTypeEnum.primary" (buttonClick)="secondaryButtonClicked.emit()">
        {{ (slidingWindowOptions$ | async)?.idleStateButtonText }}
      </app-button>
    </ng-container>
    <ng-template #defaultButtons>
      <app-button
        *ngIf="(slidingWindowOptions$ | async)?.secondaryButtonText"
        class="secondary-button"
        [type]="ButtonTypeEnum.secondary"
        (buttonClick)="secondaryButtonClicked.emit()">
        {{ (slidingWindowOptions$ | async)?.secondaryButtonText }}
      </app-button>
      <app-button
        *ngIf="!(hideActionButton$ | async)"
        [type]="ButtonTypeEnum.primary"
        (buttonClick)="primaryButtonClicked.emit()">
        {{ (slidingWindowOptions$ | async)?.primaryButtonText }}
      </app-button>
    </ng-template>
  </ng-container>
</div>

<ng-template #completed_container>
  <div class="completed-container">
    <app-button class="fill-width" [type]="ButtonTypeEnum.primary" (buttonClick)="secondaryButtonClicked.emit()">
      {{ (slidingWindowOptions$ | async)?.completedStateText }}
    </app-button>
  </div>
</ng-template>
